import { useEffect, useRef } from 'react';

export const InstagramReel = ({ url }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        // Clean URL - remove query parameters for embed
        const cleanUrl = url.split('?')[0];
        
        // Load Instagram embed script if not already loaded
        if (!window.instgrm) {
            const script = document.createElement('script');
            script.src = 'https://www.instagram.com/embed.js';
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);

            script.onload = () => {
                if (window.instgrm && window.instgrm.Embeds) {
                    window.instgrm.Embeds.process();
                }
            };
        } else {
            // If script already loaded, just process embeds
            if (window.instgrm && window.instgrm.Embeds) {
                window.instgrm.Embeds.process();
            }
        }

        // Re-process embeds when component updates
        return () => {
            if (window.instgrm && window.instgrm.Embeds) {
                window.instgrm.Embeds.process();
            }
        };
    }, [url]);

    return (
        <div className="instagram-reel-container" ref={containerRef}>
            <blockquote
                className="instagram-media"
                data-instgrm-permalink={url.split('?')[0]}
                data-instgrm-version="14"
            >
                {/* Instagram embed script will replace this content */}
            </blockquote>
        </div>
    );
};

